//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscSteps1(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 10.78L5 10.28V17H7V7.72L3 8.72V10.78Z" fill="currentColor" /><path d="M21 5H12V7H21V5Z" fill="currentColor" /><path d="M21 11H12V13H21V11Z" fill="currentColor" /><path d="M21 17H12V19H21V17Z" fill="currentColor" /></svg>;
}
export default IconMiscSteps1;